module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"subscribers_one":"подписчик","subscribers_few":"подписчика","subscribers_many":"подписчиков","subscription_one":"подписка","subscription_few":"подписки","subscription_many":"подписок","milliliters_one":"миллилитр","milliliters_few":"миллилитра","milliliters_many":"миллилитров","points_one":"поинт","points_few":"поинта","points_many":"поинтов","level":"уровень"}}')
  delete Component.options._Ctor
}
